import { Button, H5, Image, P3, Stack } from "@noom/wax-component-library";
import { useTranslation } from "react-i18next";

import errorIcon from "../../../image_assets/marketplace_error_icon.svg";

type MarketplaceErrorCardProps = {
  onRetry: () => void;
};

/**
 * Full-section error state for the marketplace: when the offers call
 * fails, every carousel is replaced by this single card prompting the
 * user to try again.
 */
export const MarketplaceErrorCard = ({ onRetry }: MarketplaceErrorCardProps) => {
  const { t } = useTranslation("care", { useSuspense: false });

  return (
    <Stack spacing={6} align="center" px={4} py={10} width="100%">
      <Image src={errorIcon} alt="" width="108px" height="108px" />
      <Stack spacing={2} align="center">
        <H5 fontWeight="400" textAlign="center">
          {t("marketplace.errorState.title")}
        </H5>
        <P3 textAlign="center">{t("marketplace.errorState.body")}</P3>
      </Stack>
      <Button
        variant="solid"
        colorScheme="primary"
        size="md"
        onClick={onRetry}
        data-cy="marketplace-error-retry"
      >
        {t("marketplace.errorState.retry")}
      </Button>
    </Stack>
  );
};
